import React from 'react'
import {dijkstra} from '../algorithms/dijkstra';
import {bfs} from '../algorithms/bfs';
import {dfs} from '../algorithms/dfs';
import {astar} from '../algorithms/astar';
import {floydWarshall} from '../algorithms/floydWarshall';
import {bellmanFord} from '../algorithms/bellmanFord';
import {createGraph, getNodesIdInShortestPathOrder} from '../algorithms/graph';

var nodesIdInShortestPathOrder

export const Animacao = ({ start, startNode, idCenario, distances, algorithm }) => {
  var graph, numberOfEdges
  var classNameOrig = idCenario === 0 ? 'sala' : idCenario === 1 ? 'sala-cenario1' : 'sala-cenario2'
  var classNameAchou = idCenario === 0 ? 'sala-achou-caminho' : idCenario === 1 ? 'sala-achou-caminho-cenario1' : 'sala-achou-caminho-cenario2'
  var classNameCaminho = idCenario === 0 ? 'sala-descobrindo-caminho' : idCenario === 1 ? 'sala-descobrindo-caminho-cenario1' : 'sala-descobrindo-caminho-cenario2'
  var classNameDisabledNode = idCenario === 0 ? 'disabledNode0' : idCenario === 1 ? 'disabledNode1' : 'disabledNode2'
  var classNameAchouConnectionV = idCenario === 0 ? 'vertical-connection-cenario0-achou' : idCenario === 1 ? 'vertical-connection-cenario1-achou' : 'vertical-connection-cenario2-achou'
  var classNameAchouConnectionH = idCenario === 0 ? 'horizontal-connection-cenario0-achou' : idCenario === 1 ? 'horizontal-connection-cenario1-achou' : 'horizontal-connection-cenario2-achou'
  var classNameAchouConnectionD1 = idCenario === 0 ? 'diagonal-connection-one-cenario0-achou' : idCenario === 1 ? 'diagonal-connection-one-cenario1-achou' : 'diagonal-connection-one-cenario2-achou'
  var classNameAchouConnectionD2 = idCenario === 0 ? 'diagonal-connection-two-cenario0-achou' : idCenario === 1 ? 'diagonal-connection-two-cenario1-achou' : 'diagonal-connection-two-cenario2-achou'
  if(idCenario === 0) {
    const numberOfVertices = 12, startNodeID = startNode, finishNodeID = 11
    const graph0 = createGraph(numberOfVertices, startNodeID, finishNodeID, distances, idCenario);
    graph = graph0
    numberOfEdges = 17
  } else if(idCenario === 1) {
    const numberOfVertices = 12, startNodeID = startNode, finishNodeID = 11
    const graph1 = createGraph(numberOfVertices, startNodeID, finishNodeID, distances, idCenario);
    graph = graph1
    numberOfEdges = 15
  } else if(idCenario === 2) {
    const numberOfVertices = 15, startNodeID = startNode, finishNodeID = 14
    const graph2 = createGraph(numberOfVertices, startNodeID, finishNodeID, distances, idCenario);
    graph = graph2
    numberOfEdges = 25
  }

  const animate = (visitedNodesInOrder, nodesInShortestPathOrder) => {
    for (let i = 0; i <= visitedNodesInOrder.length; i++) { 
      if (i === visitedNodesInOrder.length) {
        setTimeout(() => {
          animateShortestPath(nodesInShortestPathOrder, visitedNodesInOrder);
        }, 500 * i);
        return;
      }
      setTimeout(() => {
        const node = visitedNodesInOrder[i];
        document.getElementById(`${node}`).children.item(0).className = classNameCaminho;
      }, 500 * i);
    }
}
  
  const animateShortestPath = (nodesInShortestPathOrder, visitedNodesInOrder) => {
    for(let i = 0; i < visitedNodesInOrder.length; i++) { //deixando a sala da forma padrao de novo
        const node = visitedNodesInOrder[i];
        document.getElementById(`${node}`).children.item(0).className = classNameDisabledNode;
    }
    document.getElementById('alert-achou-caminho').setAttribute("style", "display:block");
    for (let i = 0; i < nodesInShortestPathOrder.length; i++) {
        setTimeout(() => {
        const node = nodesInShortestPathOrder[i];
        document.getElementById(`${node}`).children.item(0).className = classNameAchou;
        }, 500 * i);
        if(i !== nodesInShortestPathOrder.length - 1) { 
          setTimeout(() => {
          let node1 = nodesInShortestPathOrder[i];
          let node2 = nodesInShortestPathOrder[i+1];
          if (node1 > node2) {
            let aux = node1;
            node1 = node2;
            node2 = aux;
          }
          const connectionId = parseInt('1' + node1.toString() + node2.toString(), 10);
          const connectionType = document.getElementById(`${connectionId}`).children.item(0).id;
         if(connectionType === '111') {
            document.getElementById(`${connectionId}`).children.item(0).className = classNameAchouConnectionV;
          } else if(connectionType === '222') {
            document.getElementById(`${connectionId}`).children.item(0).className = classNameAchouConnectionH;
          } else if(connectionType === '333') {
            document.getElementById(`${connectionId}`).children.item(0).className = classNameAchouConnectionD1;
          } else if(connectionType === '444') {
            document.getElementById(`${connectionId}`).children.item(0).className = classNameAchouConnectionD2;
          }           
          }, 500 * i);
        }        
    }
    setTimeout(() => {
      changeButtonsVisibility(true, visitedNodesInOrder);
    }, 500 * (nodesInShortestPathOrder.length - 1));
  }

  // A diferença entre animateBF() e animate() é que esse anima as edges e não os nodes
  const animateBF = (visitedEdgesInOrder, nodesInShortestPathOrder) => {
    let classNameConnectionV = idCenario === 0 ? 'vertical-connection' : idCenario === 1 ? 'vertical-connection-cenario1' : 'vertical-connection-cenario2'
    let classNameConnectionH = idCenario === 0 ? 'horizontal-connection' : idCenario === 1 ? 'horizontal-connection-cenario1' : 'horizontal-connection-cenario2'
    let classNameConnectionD1 = idCenario === 0 ? 'diagonal-connection-one' : idCenario === 1 ? 'diagonal-connection-one-cenario1' : 'diagonal-connection-one-cenario2'
    let classNameConnectionD2 = idCenario === 0 ? 'diagonal-connection-two' : idCenario === 1 ? 'diagonal-connection-two-cenario1' : 'diagonal-connection-two-cenario2'

    document.getElementById(`${startNode}`).children.item(0).className = classNameCaminho;
    for (let i = 0; i <= numberOfEdges * 2; i++) { 
      if (i === numberOfEdges * 2) {
        setTimeout(() => {
          animateShortestPath(nodesInShortestPathOrder, [startNode]);
        }, 400 * i);
        return;
      }
      setTimeout(() => {
        let node1 = visitedEdgesInOrder[i][0];
        let node2 = visitedEdgesInOrder[i][1];
        if (node1 > node2) {
          let aux = node1;
          node1 = node2;
          node2 = aux;
        }
        const connectionId = parseInt('1' + node1.toString() + node2.toString(), 10);
        const connectionType = document.getElementById(`${connectionId}`).children.item(0).id;
        if(connectionType === '111') {
          document.getElementById(`${connectionId}`).children.item(0).className = classNameAchouConnectionV;
          setTimeout(() => {   
            document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionV;
          }, 40 * i);
        } else if(connectionType === '222') {
          document.getElementById(`${connectionId}`).children.item(0).className = classNameAchouConnectionH;
          setTimeout(() => {   
            document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionH;
          }, 40 * i);
        } else if(connectionType === '333') {
          document.getElementById(`${connectionId}`).children.item(0).className = classNameAchouConnectionD1;
          setTimeout(() => {   
            document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionD1;
          }, 40 * i);
        } else if(connectionType === '444') {
          document.getElementById(`${connectionId}`).children.item(0).className = classNameAchouConnectionD2;
          setTimeout(() => {   
            document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionD2;
          }, 40 * i);
        }           
      }, 380 * i);
    }
}

  const visualize = (algorithm) => {
    var visitedNodesIdInOrder, visitedEdgesInOrder, BF = false
    if(algorithm === "dijkstra") visitedNodesIdInOrder = dijkstra(graph)
    else if(algorithm === 'bfs') visitedNodesIdInOrder = bfs(graph)
    else if(algorithm === 'dfs') visitedNodesIdInOrder = dfs(graph)  
    else if(algorithm === 'astar') visitedNodesIdInOrder = astar(graph)
    else if(algorithm === 'floydWarshall') visitedNodesIdInOrder = floydWarshall(graph)
    else if(algorithm === 'bellmanFord') {
      visitedEdgesInOrder = bellmanFord(graph, numberOfEdges)
      visitedNodesIdInOrder = [startNode]
      BF = true
    }
    nodesIdInShortestPathOrder = getNodesIdInShortestPathOrder(graph)
    changeButtonsVisibility(false, visitedNodesIdInOrder);
    if(!BF) animate(visitedNodesIdInOrder, nodesIdInShortestPathOrder);
    else animateBF(visitedEdgesInOrder, nodesIdInShortestPathOrder);
    return;
  }

  const changeButtonsVisibility = (appear, visitedNodesInOrder) => {
    var buttonClass, nodeClass;
    if(!appear) {
      buttonClass = 'disabled';
      nodeClass = classNameDisabledNode;
    }
    else {
      buttonClass = idCenario === 0 ? 'ripple' : (idCenario === 1 ? 'ripple1' : 'ripple2');
      nodeClass = classNameOrig;
    }

    //Change header buttons visibility
    for(let i = 1; i <= 4; i++)
      if(i === 2)
        document.getElementById('header').children.item(0).children.item(`${i}`).children.item(0).className = buttonClass;
      else 
        document.getElementById('header').children.item(0).children.item(`${i}`).className = buttonClass;
    
    //Change nodes (rooms) visibility
    for(let i = 0; i < visitedNodesInOrder.length; i++)
      if(document.getElementById(`${visitedNodesInOrder[i]}`).children.item(0).className === classNameOrig
        || document.getElementById(`${visitedNodesInOrder[i]}`).children.item(0).className === classNameDisabledNode)
        document.getElementById(`${visitedNodesInOrder[i]}`).children.item(0).className = nodeClass;
  }

  return (
      <div>
          {start && visualize(algorithm)}
      </div>
  )
}

export default Animacao

export function getNodesId() {
  if(nodesIdInShortestPathOrder !== null)
    return nodesIdInShortestPathOrder;
}